import { z } from 'zod'
import { CommunicationType, type PeripheralPrinterSettings } from '../../models/PeripheralSettings'
import { CommandType } from '../../models/PeripheralManufacturer'

export const PeripheralPrinterSettingsDTO = z.object({
  address: z.string().nullish(),
  port: z.number().nullish(),
  printer_model: z.string().nullish(),
  communication_type: z.nativeEnum(CommunicationType).nullish(),
  command_type: z.nativeEnum(CommandType).nullish()
})

export type PeripheralPrinterSettingsDTO = z.infer<typeof PeripheralPrinterSettingsDTO>

export function mapPeripheralPrinterSettingsToDTO (model: PeripheralPrinterSettings): PeripheralPrinterSettingsDTO {
  return {
    address: model.address,
    port: model.port,
    printer_model: model.model,
    communication_type: model.communicationType,
    command_type: model.commandType
  }
}

export function mapDTOToPeripheralPrinterSettings (dto: PeripheralPrinterSettingsDTO): PeripheralPrinterSettings {
  return {
    address: dto.address ?? undefined,
    port: dto.port ?? undefined,
    model: dto.printer_model ?? undefined,
    communicationType: dto.communication_type ?? undefined,
    commandType: dto.command_type ?? undefined
  }
}
